"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _crowdaaApi = _interopRequireDefault(require("crowdaa-api"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _reactIntl = require("react-intl");

var _reactRefetch = require("react-refetch");

var _faShareAlt = _interopRequireDefault(require("@fortawesome/fontawesome-free-solid/faShareAlt"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _ErrorMessage = _interopRequireDefault(require("./ErrorMessage"));

var _Loading = _interopRequireDefault(require("./Loading"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  _setPrototypeOf(subClass.prototype, superClass && superClass.prototype);

  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.getPrototypeOf || function _getPrototypeOf(o) {
    return o.__proto__;
  };

  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var ShareUnlockButton =
/*#__PURE__*/
function (_React$PureComponent) {
  function ShareUnlockButton() {
    _classCallCheck(this, ShareUnlockButton);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShareUnlockButton).apply(this, arguments));
  }

  _createClass(ShareUnlockButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          shareFetch = _this$props.shareFetch,
          postShare = _this$props.postShare;
      if (shareFetch.rejected) return _react.default.createElement(_ErrorMessage.default, {
        error: shareFetch.reason
      });
      return _react.default.createElement("button", {
        className: "btn btn-success rounded-0",
        onClick: postShare
      }, shareFetch.pending && _react.default.createElement(_Loading.default, null), shareFetch.rejected && _react.default.createElement(_ErrorMessage.default, {
        error: shareFetch.reason
      }), !shareFetch.pending && !shareFetch.rejected && _react.default.createElement("div", null, _react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
        icon: _faShareAlt.default,
        className: "mr-1"
      }), _react.default.createElement(_reactIntl.FormattedMessage, {
        id: "share"
      })));
    }
  }]);

  _inherits(ShareUnlockButton, _React$PureComponent);

  return ShareUnlockButton;
}(_react.default.PureComponent);

_defineProperty(_defineProperty(_defineProperty(ShareUnlockButton, "propTypes", {
  shareFetch: _propTypes.default.object,
  postShare: _propTypes.default.func.isRequired
}), "contextTypes", {
  apiURL: _propTypes.default.string,
  intl: _reactIntl.intlShape,
  loginToken: _propTypes.default.string,
  userId: _propTypes.default.string
}), "defaultProps", {
  shareFetch: {}
});

var _default = _reactRefetch.connect.defaults(new _crowdaaApi.default())(function (props, context) {
  var apiURL = context.apiURL;
  return {
    postShare: function postShare() {
      return {
        shareFetch: {
          context: context,
          url: "".concat(apiURL, "/tokens/packages/").concat(props.packageId),
          method: 'POST',
          force: true,
          then: function then(res) {
            props.handleBtnClicked();
            return {
              value: res
            };
          }
        }
      };
    }
  };
})(ShareUnlockButton);

exports.default = _default;